import React, { useEffect, Fragment } from 'react';
import { useNavigate } from "react-router-dom";
import Page from "../Page";
import PageContentWrapper from "../../components/PageContentWrapper";
import ListingPageComponent from '../../components/ListingPageComponent';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import UI_ACTIONS from '../../data/UiActionConstants';
import { getApi } from '../../api/endpoints';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import UiAction from '../../components/UiAction';

const Index = () => {
  const navigate = useNavigate();
  const defaultHeaderConfig = { disableSort: false };
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Name',
      attr: 'name',
    },
    {
      ...defaultHeaderConfig,
      label: 'Email',
      attr: 'email',
    },
    {
      ...defaultHeaderConfig,
      label: 'Mobile No.',
      attr: 'mobile_number',
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_crm_user.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onEditClick(row.id) }>
              <FontAwesomeIcon icon={faEdit}/>
            </div>
          </UiAction>
        </div>
      }
    }
  ]

  const onEditClick = (id) => {
    navigate(`/crm/users/${id}/edit`)
  }

  const onNewClick = () => {
    navigate(`/crm/users/new`)
  }

  const tableHeaderActionsComponent = () => {
    return <Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_crm_user.name)}>
        <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
          <span>Add New User</span>
        </button>
      </UiAction>
    </Fragment>
  }

  return <ListingPageComponent
    key={PAGES.CrmUsersListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.CrmUsersListingPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Crm Users'}]}
    listingMutation={getApi('crmUsers')}
    className="customers-listing-page"
    contentHeading="Crm Users - Results"
    headers={headers}
    recordsKey="crm_users"
    tableHeaderActionsComponent={tableHeaderActionsComponent()}
  />
};

export default Index;


